const features = {
  state: [
    {
      id: '1',
      src: require('@/assets/img/wallet.png'),
      bg: require('@/assets/img/img21.png'),
      title: 'Live Betting',
      text:
        'Create or join bets on live matches featured in the GG dApp and collect winnings.',
    },
    {
      id: '2',
      src: require('@/assets/img/wallet.png'),
      bg: require('@/assets/img/img22.png'),
      title: 'Token Rewards',
      text:
        'GG rewards content creators that positively engage with the  community, by periodically distributing tokens and NFTs.',
    },
    {
      id: '3',
      src: require('@/assets/img/wallet.png'),
      bg: require('@/assets/img/img23.png'),
      title: 'Staking',
      text:
        'Stake tokens to get access  to governance. Rewards include tokens and NFTs.',
    },
    {
      id: '4',
      src: require('@/assets/img/wallet.png'),
      bg: require('@/assets/img/img21.png'),
      title: 'GG Marketplace',
      text:
        'Create your own NFT or buy from the GG Marketplace featuring the hottest eSports products.',
    },
  ],
}
export default features
